import Pages from './containers/Pages';

export const pagesRoutes = {
    path: '/page/:page',
    component: Pages
}


// WEBPACK FOOTER //
// ./src/pages/routes.js